import { FC } from "react";
import { useRecoilValue } from "recoil";

import { RASTER_LANDINGS } from "@ryde/assets-landings";
import { onActivateKeyDown } from "@ryde/shared";
import {
  landingActiveStepAtom,
  LandingStepEnum,
  useLandingActions,
  useLandingLangSwitch,
} from "@ryde/utils-landings";

import {
  StepChooseStationWix,
  StepErrorWix,
  StepFinishedWix,
  StepLoginWix,
  StepVerifyCodeWix,
} from "../../steps-wix";

export const WixLandingStepsContainer: FC = () => {
  const step = useRecoilValue(landingActiveStepAtom);
  const { goToStep } = useLandingActions();
  useLandingLangSwitch();

  return (
    <div className="landing-outside-container">
      <div className="landing-container">
        <div
          className="landing-logo"
          role="button"
          tabIndex={0}
          onClick={() => goToStep(LandingStepEnum.LoginStep)}
          onKeyDown={onActivateKeyDown(() =>
            goToStep(LandingStepEnum.LoginStep),
          )}
          aria-label="Go to homepage"
        >
          <img
            className="landing-logo__img landing-logo__img--wix"
            src={RASTER_LANDINGS.WixLogoPNG}
            alt="Wix logo"
          />
        </div>
        {(!step || step === LandingStepEnum.LoginStep) && <StepLoginWix />}
        {step === LandingStepEnum.VerificationStep && <StepVerifyCodeWix />}
        {step === LandingStepEnum.ChooseStationStep && <StepChooseStationWix />}
        {step === LandingStepEnum.FinishedStep && <StepFinishedWix />}
        {step === LandingStepEnum.ErrorStep && <StepErrorWix />}
      </div>
    </div>
  );
};
